import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import './styles.css';

const NotFound: React.FC = () => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={`body-wrapper auth-wrapper d-flex align-items-stretch ${darkMode ? 'dark-mode' : ''}`}>
      <div className="d-flex flex-grow flex-column-reverse flex-sm-row w-100">
        <div className="auth-bg py-5 py-sm-0 col-sm-6">
          <p className="auth-credits py-5">
            <span className="footer-message">
              Feito com <Icon name="heart" size={16} color="red" /> Trending<br />
            </span>
          </p>
        </div>
        <div className="auth-panel-wrapper col">
          <div className="auth-panel py-5 text-center">
            <img 
              src="/logo-trading.png" 
              alt="Trading Logo"
              style={{ width: '170px', height: 'auto', transform: 'scaleY(2.2)' }}
            />
            <div className="auth-header mt-4">
              <h4 className="auth-title">404 - Página não encontrada</h4>
              <p className="auth-subtitle">Ops! O conteúdo que você procura não existe.</p>
            </div>
            <Button type="button" variant="auth" fullWidth onClick={() => navigate(-1)}>
              Voltar
            </Button>
            <p className="tip text-center mt-2">
              <Link to="/login" className="auth-link">
                Ir para o Login
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
